export class CreateCandidateJobOfferClass {
    jobLanguage?: string;
    title?: string;
    jobType?: string[];
    placeOfWork?: string;
    startDate?: number;
}
